import axios from 'axios'
import { apiHost } from '@/config/routes'

// apiHost se referencia dentro de las funciones (lazy) para evitar que se evalúe
// como undefined en el momento en que se importa el módulo

export default {
  async getTours(token) {
    try {
      const response = await axios.get(`${apiHost}/channel/api/onboarding/tours`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      return {
        tours: response.data?.data || {},
        userCreatedAt: response.data?.userCreatedAt || null
      }
    } catch (error){
      console.error('Error fetching tours from backend: ', error)
      return null
    }
  },

  async upsertTour(token, { tourName, completed, lastStep }) {
    try {
      await axios.post(
        `${apiHost}/channel/api/onboarding/tour`,
        { tourName, completed, lastStep },
        { headers: { Authorization: `Bearer ${token}` } }
      )
    } catch {
      // fire-and-forget: localStorage sigue siendo la fuente de verdad local
    }
  }
}
